import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectForm,
  selectLoading,
  selectSettings,
} from '../../userManagement/settingPreferences/store/slice'
import { getUserSettingWithPreference } from '../../userManagement/settingPreferences/store/thunk'

const useGetUserSettingWithPreference = (disableCallApi) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectLoading)
  const userSettings = useSelector(selectSettings)
  const userPreferences = useSelector(selectForm)

  useEffect(() => {
    if (!disableCallApi) {
      dispatch(getUserSettingWithPreference())
    }
  }, [])

  return {
    loading,
    userSettings,
    userPreferences,
  }
}

export default useGetUserSettingWithPreference
